module.exports = __webpack_public_path__ + "static/reward1-title.0cbdfd36.png";